module.exports = __webpack_public_path__ + "static/media/slider-agency-website-slide-01-bg.6ff43134.jpg";